import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">
            分类快捷入口
          </h2>
          <p className="mt-1 text-sm text-foreground-600">按兴趣快速找到你想看的视频类型</p>
        </div>
        <Link
          to="/category/comedy"
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          全部分类
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line" />
          </span>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {categories.map((c) => {
          const count = videos.filter((v) => v.category === c.slug).length;
          return (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-colors"
            >
              <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${c.icon} text-2xl`} />
              </span>
              <span className="text-sm font-semibold text-foreground-900">{c.name}</span>
              <span className="text-xs text-foreground-500">{count} 个视频</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}